@if (!hasBeenCopied()) {
  <div class="bg-background-pms-yellow typo-h5-medium flex items-center gap-1 pb-1 pl-3 pt-2 text-text-primary">
    <svg-icon
      class="max-h-5 max-w-5 text-states-orange"
      key="px-16-info"
      size="md"
      [libUiTooltip]="copyToPmsTooltip"
      tooltipPosition="bottom"
    />
    {{ 'ffd_notes_copy_to_pms' | translate }}
  </div>
}

<ng-template #copyToPmsTooltip>
  <div class="typo-h7-light whitespace-pre-line text-text-primary" [innerHTML]="'ffd_notes_copy_to_pms_tooltip' | translate"></div>
</ng-template>

<div class="px-4 pb-4 pt-3" [class.!pb-0]="isExpanded && maxHeight()">
  <div class="mb-2 flex items-center justify-between gap-x-1">
    <div
      class="typo-h4-semibold line-clamp-2 min-h-[24px] !whitespace-normal break-all"
      [ngClass]="{
        'cursor-pointer': expandable()
      }"
      libHighlight
      [searchTerm]="searchTerm()"
      [text]="noteContent()"
      classesToApply="bg-states-orange text-text-white"
      (click)="toggleExpandedNote()"
    ></div>
    @if (!hideMenu()) {
      <button
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        (click)="onMenuClick($event)"
        class="flex h-4 w-4 items-center justify-center"
        [disabled]="isProvisional() && !isLocked()"
      >
        <svg-icon key="px-16-more" size="sm" class="text-primary-blue"></svg-icon>
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayPositions]="overlayPositionStrategy"
        [cdkConnectedOverlayOpen]="dropdownOpen()"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="['opacity-0']"
        (backdropClick)="toggleDropdown()"
      >
        <div
          class="z-[1] flex w-[270px] select-none flex-col justify-between gap-2 rounded-[28px] border-2 border-states-white bg-background-white/80 p-4 shadow-card backdrop-blur-overlay"
        >
          @if (!isLocked()) {
            <button
              class="btn-text flex items-center justify-between rounded-md px-2.5 py-1.5 text-text-primary hover:bg-background-light-blue active:text-text-primary"
              (click)="onCopyNote()"
            >
              <h4 class="typo-h4-medium">{{ 'express_notes_copy_note' | translate }}</h4>
              <svg-icon [key]="'px-24-layers'" class="min-h-6 min-w-6"></svg-icon>
            </button>
            <hr class="border-text-white" />
            <button
              class="btn-text flex items-center justify-between rounded-md px-2.5 py-1.5 text-text-primary hover:bg-background-light-blue active:text-text-primary"
              (click)="onEditNote()"
            >
              <h4 class="typo-h4-medium">{{ (inEditMode() ? 'notes_menu_cancel_edit' : 'notes_menu_edit_note') | translate }}</h4>
              <svg-icon [key]="inEditMode() ? 'px-12-x' : 'px-24-pencil'" class="min-h-6 min-w-6"></svg-icon>
            </button>
            <hr class="border-text-white" />
            <button
              class="btn-text flex items-center justify-between rounded-md px-2.5 py-1.5 text-states-red hover:bg-background-light-blue active:text-states-red"
              (click)="onDeleteNote()"
            >
              <h4 class="typo-h4-medium">{{ 'notes_menu_delete_note' | translate }}</h4>
              <svg-icon key="px-16-delete" class="min-h-6 min-w-6"></svg-icon>
            </button>
          }
        </div>
      </ng-template>
    }
  </div>
  @if (expandable()) {
    @if (!isExpanded) {
      <button (click)="isExpanded = true" class="typo-h4-semibold mb-3 text-primary-blue">
        {{ 'charting_details_notes_expand_note' | translate }}
      </button>
    } @else if (isExpanded && noteContent() && noteContent().length > 500) {
      <button (click)="isExpanded = false" class="typo-h4-semibold mb-3 text-primary-blue">
        {{ 'charting_details_notes_collapse_note' | translate }}
      </button>
    }
  }
  <div class="flex items-center justify-between text-text-light">
    <div class="flex items-center gap-2">
      @if (isProvisional() || isLocked()) {
        <div class="flex h-7 w-7 items-center justify-center rounded-[10px] bg-background-light-grey">
          <svg-icon
            [key]="isProvisional() ? 'px-20-provisional-locked' : 'px-16-locked'"
            size="sm"
            class="min-w-fit text-text-light"
          ></svg-icon>
        </div>
      }
      @if (noteTitle()) {
        <div class="flex items-center gap-1">
          <svg-icon class="text-primary-blue" key="px-24-dentist" size="sm"></svg-icon>
          <h5 class="typo-h5-book text-text-light">
            {{ noteTitle() }}
          </h5>
        </div>
      } @else {
        <div class="flex items-center gap-1 rounded-md bg-background-disabled px-2 py-1 text-text-tertiary">
          <svg-icon key="px-24-dentist" size="sm"></svg-icon>
          <h5 class="typo-h5-book">
            {{ 'express_notes_unassigned' | translate }}
          </h5>
        </div>
      }
    </div>

    <h5 class="typo-h5-book">
      {{ date() | date: dateTimeFormat }}
    </h5>
  </div>
  @if (expandable()) {
    @if (isExpanded) {
      <hr class="my-3 text-background-disabled" />
    }

    <div class="relative">
      <div
        class="typo-h4-light whitespace-pre-line text-text-secondary"
        [ngClass]="{
          'h-0 overflow-hidden': !isExpanded && !isAnimating(),
          'mt-3': isExpanded,
          'overflow-y-scroll pb-10': maxHeight() && isExpanded
        }"
        [style]="{
          maxHeight: maxHeight() ? maxHeight() + 'px' : 'none'
        }"
        [@expandAnimation]="isExpanded ? 'expanded' : 'collapsed'"
        (@expandAnimation.start)="setNoteExpandAnimationState(true)"
        (@expandAnimation.done)="setNoteExpandAnimationState(false)"
      ></div>
      @if (isExpanded && maxHeight()) {
        <div class="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-background-white to-transparent"></div>
      }
    </div>
    @if (isExpanded && !maxHeight()) {
      <button (click)="closeExpandedNote()" class="typo-h4-semibold mt-3 text-primary-blue">
        {{ 'charting_details_notes_collapse_note' | translate }}
      </button>
    }
  }
</div>
